import React from 'react';
import styled from 'styled-components';

import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';

import {
    useCurrentTracklog,
    useDebriefApp,
    useMapControls,
    useAnalytics,
} from 'ff/debrief/hooks';

import ControlPanel from 'ff/debrief/layouts/ControlPanel';
import LayerSelector from 'ff/debrief/components/map/LayerSelector';
import MapZoomControls from 'ff/debrief/components/map/MapZoomControls';
import { AeroToggleButtons } from 'ff/debrief/components/map/settings/AeroToggleButtons';
import DeclutterIcon from 'ff/debrief/components/customIcons/declutterIcon';
import RouteIcon from 'ff/debrief/components/customIcons/RouteIcon';
import { isFeatureEnabled } from 'ff/common/ffAppUtils';
import MapModeToggle from 'ff/debrief/components/map/MapModeToggle';

const MapControls = () => {
    const { logDeclutterButtonClicked } = useAnalytics();
    const { aeroLayer } = useMapControls();
    const { isDecluttering, toggleDecluttering } = useDebriefApp();
    const { viewport, hasCloudAhoyDebrief } = useCurrentTracklog();
    const { controls } = useMapControls();

    const handleSnapToRouteClick = () => {
        controls.flyToBounds(viewport.bounds);
    };

    const handleDeclutterClick = () => {
        logDeclutterButtonClicked({
            state: isDecluttering ? 'open' : 'closed',
        });
        toggleDecluttering();
    };

    return (
        <ControlPanel>
            <ButtonColumn>
                <UpperSection>
                    <UpperItem>
                        <LayerSelector />
                        {isFeatureEnabled('debrief_3d_map') && (
                            <MapModeToggle />
                        )}
                    </UpperItem>
                </UpperSection>
                <LowerSection spacing={1}>
                    {window.currentUser && aeroLayer && <AeroToggleButtons />}
                    <Stack spacing="1px">
                        {hasCloudAhoyDebrief && (
                            <Paper
                                sx={{
                                    bgcolor: isDecluttering
                                        ? '#3498DB'
                                        : undefined,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '32px',
                                    width: '32px',
                                    padding: 0,
                                    borderRadius: '4px 4px 0 0',
                                }}
                            >
                                <IconButton
                                    size="small"
                                    onClick={handleDeclutterClick}
                                >
                                    <DeclutterIcon
                                        sx={{
                                            width: '20px',
                                            color: isDecluttering
                                                ? '#FFFFFF'
                                                : '#000000',
                                        }}
                                    />
                                </IconButton>
                            </Paper>
                        )}
                        <Paper
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '32px',
                                width: '32px',
                                padding: 0,
                                borderRadius: hasCloudAhoyDebrief
                                    ? '0 0 4px 4px'
                                    : '4px 4px 4px 4px',
                            }}
                        >
                            <IconButton
                                size="small"
                                onClick={handleSnapToRouteClick}
                            >
                                <RouteIcon
                                    sx={{ width: '16px', color: '#000000' }}
                                />
                            </IconButton>
                        </Paper>
                    </Stack>
                    <MapZoomControls />
                </LowerSection>
            </ButtonColumn>
        </ControlPanel>
    );
};

const UpperSection = styled(Stack)`
    flex-direction: row;
`;

const UpperItem = styled.div`
    margin: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const LowerSection = styled(Stack)``;

const ButtonColumn = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export default MapControls;
